import React from 'react';

const InputField = React.forwardRef(({ label, error, className = "", ...props }, ref) => {
  return (
    <div className={className}>
      <label className="block text-sm text-darkGray mb-1">
        {label}
      </label>
      <input
        ref={ref}
        className={`w-full border rounded-xl px-3 h-10 text-darkGray focus:outline-none ${
          error ? 'border-red' : 'border-secondary'
        }`}
        {...props}
      />
      {error && (
        <span className="text-red text-xs mt-1 block">
          {error.message}
        </span>
      )}
    </div>
  );
});

export default InputField;